
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";
import { Configuration } from "../models/appConfig";
import CustomHtmlComponent from "@/components/CustomHtmlComponent.vue";
import Axios from "axios";

@Component({
  computed: {
    ...mapGetters("oidcStore", ["oidcUser"])
  },
  methods: {
    ...mapActions("oidcStore", ["signOutOidc"])
  },
  components: { CustomHtmlComponent }
})
export default class Header extends Vue {
  @Prop() logoutUrl!: string;

  private issuerName = "";

  @Prop() helpDialog!: boolean;
  private helpDialogOpened = false;
  private helpDialogEnabled = false;
  private helpContent = "";

  beforeCreate() {
    const appConfig = this.$store.getters[
      "configuration/getConfiguration"
    ] as Configuration;

    if (appConfig.app.help?.enabled) {
      Axios.get("/help.html").then(htmlContent => {
        this.helpContent = htmlContent.data;
      });
    }
  }

  created() {
    const appConfig = this.$store.getters[
      "configuration/getConfiguration"
    ] as Configuration;
    this.issuerName = appConfig.app.issuer.name;

    if (appConfig.app.help?.enabled) {
      this.helpDialogEnabled = true;
    }
  }

  closeHelp() {
    this.helpDialog = false;
    this.$emit("helpDialog", false);
  }
}
